<template>
  <div>  
    <!-- 請求取消処理ダイアログ -->
    <ListDialog ref="cancelBookSalesDialog" title="請求取消処理" :captions="[]" :widths="[]" :showAdd="false" :showRemove="false" :exec="submitCancelBookSales" >
    <template slot="header" slot-scope="{  }">請求取消処理を開始します。</template>
    </ListDialog>
  </div>
</template>


<script lang="ts">
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class CancelBookSales extends Vue {
  @Prop() public checkedDeliveryItems:Array<Common.SalesDeliveryItem>;
  @Prop() public parentMainList:Components.ListView;
  @Prop() public gridVoucherItem:Components.GrdVoucherItem;

   // 請求取消処理ダイアログの表示
  public mounted() {
    // ダイアログ表示前バリデーション
    if(this.checkedDeliveryItems.length == 0){
      this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);      
      return;
    }
    if(this.checkedDeliveryItems.filter(item => item.state != Common.StockBalanceJournalStatus.SalesDeliveryClosingWaiting).length > 0){
      this.$api.modal.show('', '請求締待ちの明細のみを選択して下さい。', true, null);
      return;
    }

    // ダイアログの表示
    (this.$refs.cancelBookSalesDialog as Components.ListDialog).showDialog();
  }

  // 請求取消処理の実行
  public async submitCancelBookSales() {
    // 実行前バリデーション
    if(this.checkedDeliveryItems.length == 0){
      return;
    }
    // クエリの設定
    var query = new Common.CancelBookSalesQuery();
    query.deliveryItems = this.checkedDeliveryItems;

    (this.$refs.cancelBookSalesDialog as Components.ListDialog).closeDialog();
    // 請求取消処理の実行
    return this.$api.execute(query,true).then(()=>{ 
      if(this.parentMainList) this.parentMainList.reload()
      if(this.gridVoucherItem) this.gridVoucherItem.onVoucherNoChanged();
      this.$api.modal.show('処理結果','請求取消処理が完了しました。',true,null);
      return true;        
      }).catch(()=>false);     
  }
}
  </script>